module.exports = __webpack_public_path__ + "img/sbanner_03.b8d0039f.jpg";